import { render, staticRenderFns } from "./DiseaseInfo.vue?vue&type=template&id=8fadac7e&"
import script from "./DiseaseInfo.vue?vue&type=script&lang=js&"
export * from "./DiseaseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports